export default nextState => dispatch => {
    dispatch({ type: "TOGGLE_APP_LOADER", payload: nextState })
}